import { procent } from "./procent";
import store from '../store'
export const addProcentToTable = table => {
  table.map(item => {
    item.ikomProcent = procent(
      item.ikom,
      store.getters.calc.summ,
      store.getters.calc.days,
      store.getters.calc.yearProcent
    );
    item.ikomskProcent = procent(
      item.ikomsk,
      store.getters.calc.summ,
      store.getters.calc.days,
      store.getters.calc.yearProcent
    );
    item.ikomClientProcent = procent(
      item.ikomClient,
      store.getters.calc.summ,
      store.getters.calc.days,
      store.getters.calc.yearProcent
    );
  });
  return table;
};
